import { Button, Flex, Modal, Typography } from "antd";
import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CheckOutlined } from "@ant-design/icons";
import { colors } from "../../../constants/colors";
import { baseRouteMaker, routes } from "../../../constants/routeConsts";
import "./StripePayment.scss";

const PaymentConfirmationDialog = ({ open, onClose }) => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  /* loading dependencies */

  const handleDialogClose = () => {
    onClose();
    navigate(baseRouteMaker(routes.DASHBOARD))
  };

  return (
    <Modal
      open={open}
      onCancel={handleDialogClose}
      footer={false}
      confirmLoading={loading}
      width={500}
    >
      <div className="paymentDialogContainer">
        <Flex vertical gap="1rem" align="center" justify="center">
          <div className="paymentCheckIconContainer">
            <CheckOutlined />
          </div>
          <Typography.Title level={1} style={{ color: colors.emaraldGreen }}>
            {t("CommonUtils.thankYou")}
          </Typography.Title>
          <Typography.Paragraph level={1} style={{ margin: 0 }}>
            {t("CommonUtils.paymentSuccess")}
          </Typography.Paragraph>
            <Button
            style={{
                background: colors.emaraldGreen,
                color: colors.white,
            }}
            onClick={() => navigate(baseRouteMaker(routes.DASHBOARD))}
            >
            {t("CommonUtils.goToDashboard")}
            </Button>
        </Flex>
      </div>
    </Modal>
  );
};

export default PaymentConfirmationDialog;
